import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/buttons";
import { getTranslations, type Locale } from "@/lib/i18n/config";
interface NewSessionDialogProps {
  onConfirm?: () => void;
  onCancel?: () => void;
  locale?: Locale;
}

/**
 * Confirmation card shown before a new agent conversation is started.
 * Replaces the chat history + footer while visible (see `Agent.tsx`).
 */
export const NewSessionDialog: React.FC<NewSessionDialogProps> = t0 => {
  const $ = _c(19);
  const {
    onConfirm,
    onCancel,
    locale: t1
  } = t0;
  const locale = t1 === undefined ? "de" : t1;
  let t2;
  if ($[0] !== locale) {
    t2 = getTranslations(locale);
    $[0] = locale;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    agent: t
  } = t2;
  let t3;
  if ($[2] !== t.newSession.title) {
    t3 = <h3 className="text-2xl font-medium">{t.newSession.title}</h3>;
    $[2] = t.newSession.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t.newSession.description) {
    t4 = <p className="text-black/80">{t.newSession.description}</p>;
    $[4] = t.newSession.description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onConfirm || $[7] !== t.newSession.confirm) {
    t5 = <Button variant="primary" color="purple" label={t.newSession.confirm} onClick={onConfirm} className="w-full" />;
    $[6] = onConfirm;
    $[7] = t.newSession.confirm;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onCancel || $[10] !== t.newSession.cancel) {
    t6 = <Button variant="secondary" color="purple" label={t.newSession.cancel} onClick={onCancel} className="w-full" />;
    $[9] = onCancel;
    $[10] = t.newSession.cancel;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="mt-2 flex flex-col gap-3">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t7) {
    t8 = <div className="flex flex-1 items-start justify-center px-4 pb-safe-area"><section className="flex w-full flex-col gap-4 rounded-3xl bg-white p-6 text-black">{t3}{t4}{t7}</section></div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};